import "./single-marketplace.scss";
import "../../../js/core";

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(() => {
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(() => {

        jQuery(".slider-images").owlCarousel({
          
          items: 1,
          loop: false,
          nav: true,
          dotsEach: true,
          slideBy: 1,
          margin: 20,
          smartSpeed: 200,
        });
        
        jQuery(".slider-card-solution").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
            },
            768: {
              items: 2,
              dots: true,
            },
            992: {
              items: 3,
              dots: false,
            },
          },
          loop: false,
          nav: true,
          dotsEach: true,
          slideBy: 1,
          margin: 20,
          smartSpeed: 200,
        });
        $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
        });
    });
  });
});